import { dataLocationPinSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLocationPinSolid = /*#__PURE__*/createIcon(dataLocationPinSolid)
export default IconLocationPinSolid
